import React from 'react';
import Modal from 'react-responsive-modal';
import Translate from 'translate';
import moment from 'moment';
import { Card, CardText } from 'material-ui';

export default ( { data, onClose, open } ) => {
  return (
    <Modal closeOnEsc={false}
           little
           modalClassName="col-md-4"
           open={open}
           onClose={onClose}>
      <h5 className="mt-0"><Translate id="imsDetailAPU"/></h5>
      { data && data.result===false &&
      <div className="col-md-12 text-center">
            <h5 className="text-muted mt-0"><Translate id="noDataFound"/></h5>
      </div>
      }
      { data && data.result!==false &&
      <Card>

      
      <CardText>
      <div className="col-md-12 p-0">
        <div className="row">
          <div className="col-md-3"><Translate id="complaintNumber"/></div>
          <div className="col-md-9 text-small text-muted">{data.code}</div>
        </div>
        <div className="row">
          <div className="col-md-3"><Translate id="address"/></div>
          <div className="col-md-9 text-small text-muted">{data.address}</div>
        </div>
        <div className="row">
          <div className="col-md-3"><Translate id="status"/></div>
          <div className="col-md-9 text-small text-muted">{data.status || '---'}</div>
        </div>
        <div className="row">
          <div className="col-md-3"><Translate id="creationDate"/></div>
          <div className="col-md-9 text-small text-muted">{moment( data.createDate ).format( 'DD/MM/YYYY hh:mmA' ) || '---'}</div>
        </div>

        <div className="row">
          <div className="col-md-3"><Translate id="incidentAPU"/></div>
          <div
            className="col-md-9 text-small text-muted">{data.type || '---'}</div>
        </div>

        <div className="row">
          <div className="col-md-3"><Translate id="incidentDescription"/></div>
          <div
            className="col-md-9 text-small text-muted">{data.comments || '---'}</div>
        </div>


      </div>
      </CardText></Card>
      }
    </Modal>
  )
}



// WEBPACK FOOTER //
// ./routes/app/components/Agent/CheckImsAPUModal/index.js